'use client'

import { Container } from '@/components/container'
import { Button } from '@/components/button'
import { MotionDiv } from '@/components/motion-wrapper'
import { trackEvent } from '@/lib/utils'
import { useEffect, useRef } from 'react'

export function CTASection() {
  const sectionRef = useRef<HTMLElement>(null)
  const hasTrackedView = useRef(false)

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !hasTrackedView.current) {
            hasTrackedView.current = true
            trackEvent('section_viewed', {
              event_category: 'engagement',
              event_label: 'cta_section',
              value: 1,
            })
          }
        })
      },
      { threshold: 0.5 }
    )

    if (sectionRef.current) {
      observer.observe(sectionRef.current)
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current)
      }
    }
  }, [])

  return (
    <section ref={sectionRef} className="py-24 bg-gradient-to-br from-gray-900 to-gray-800 text-white">
      <Container>
        <MotionDiv
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center max-w-3xl mx-auto"
        >
          <h2 className="text-4xl font-semibold tracking-tight sm:text-5xl md:text-6xl">
            Ready to Transform Your Idea into Reality?
          </h2>
          <p className="mt-6 text-xl text-gray-300 sm:text-2xl">
            Let&apos;s discuss your project and explore how we can help build your scalable MVP or SaaS product.
          </p>
          <div className="mt-8">
            <Button
              variant="secondary"
              data-cal-namespace="15min"
              data-cal-link="mohammed-saket-d4virq/15min"
              data-cal-config='{"layout":"month_view"}'
              className="!bg-white !text-gray-900 hover:!bg-gray-50 !border-transparent !ring-0 !shadow-lg hover:!shadow-xl transition-all duration-200 font-semibold"
              onClick={() => {
                trackEvent('book_button_clicked', {
                  event_category: 'engagement',
                  event_label: 'cta_section',
                  value: 1,
                })
              }}
            >
              Book a Free Consultation
            </Button>
          </div>
        </MotionDiv>
      </Container>
    </section>
  )
}

